import React, { useMemo } from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useZinantisMembers } from '../../../../contextsProperty/ContextZinantisMembers';
import MemberSegment from './MemberSegment';
import Card from '../../../../../muiComponents/Card';
import { PENDING_MEMBER_STATUS_KEY } from '../../../../../utils/zinantis/members/membersUtils';
import { PENDING_REQUEST_STATUS_KEY } from '../../../../../utils/zinantis/requests/requestsUtils';
import { ConnetionRequestSource } from '../../../../../types/zinantis/connectionRequests/connectionRequestTypes';
import IncomingRequestsAlert from '../IncomingRequestsAlert';

const MembersCardsView = () => {
    const {
        members,
        membersWithoutSegment,
        connectedMembers,
        newMembers,
        accountManagementSegments,
        getFilteredMembers,
        filters,
    } = useZinantisMembers();
    const translate = useTranslate();

    const filteredConnectedMembers = useMemo(() => {
        return getFilteredMembers(connectedMembers);
    }, [connectedMembers, filters]);

    const filteredNewMembers = useMemo(() => {
        return getFilteredMembers(newMembers);
    }, [newMembers, filters]);

    const filteredMembersWithoutSegment = useMemo(() => {
        return getFilteredMembers(membersWithoutSegment);
    }, [membersWithoutSegment, filters]);

    const filteredMembers = useMemo(() => {
        return getFilteredMembers(members);
    }, [members, filters]);

    const pendingMembers = useMemo(() => {
        return members.filter(
            member =>
                member.statusKey === PENDING_MEMBER_STATUS_KEY &&
                member.connectionRequests.filter(
                    request =>
                        request.statusKey === PENDING_REQUEST_STATUS_KEY &&
                        request.requestedBy === ConnetionRequestSource.AGENCY
                ).length
        );
    }, [members]);

    const connectedMembersButtonBar = useMemo(() => {
        const pendingRequestsCount = pendingMembers.length;
        if (pendingRequestsCount === 0) return undefined;
        return <IncomingRequestsAlert />;
    }, [pendingMembers, translate]);

    return (
        <div
            className='flex-column gap-40 flex-grow'
            style={{
                overflow: 'auto',
            }}
        >
            {filteredConnectedMembers &&
                filteredConnectedMembers.length > 0 && (
                    <MemberSegment
                        totalMembersCount={connectedMembers.length}
                        segment={translate('my_connections')}
                        members={filteredConnectedMembers}
                        visibleSegmentName={true}
                        visibleNewMember={true}
                        headerButtonbar={connectedMembersButtonBar}
                    />
                )}
            {filteredNewMembers && filteredNewMembers.length > 0 && (
                <MemberSegment
                    totalMembersCount={newMembers.length}
                    segment={translate('new_plural')}
                    members={filteredNewMembers}
                    visibleSegmentName={true}
                />
            )}
            {accountManagementSegments.map(segment => {
                const segmentMembers = members.filter(
                    member =>
                        member.idAccountManagementSegment ===
                        parseInt(segment.id)
                );
                const filteredSegmentMembers =
                    getFilteredMembers(segmentMembers);
                if (!filteredSegmentMembers.length) return null;
                return (
                    <MemberSegment
                        key={segment.id}
                        totalMembersCount={segmentMembers.length}
                        segment={segment.name}
                        members={filteredSegmentMembers}
                        visibleSegmentName={false}
                        visibleNewMember={true}
                    />
                );
            })}
            {/* sin sección */}
            {filteredMembersWithoutSegment.length > 0 ? (
                <MemberSegment
                    segment={translate('other-rest')}
                    totalMembersCount={membersWithoutSegment.length}
                    members={filteredMembersWithoutSegment}
                    visibleSegmentName={false}
                    visibleNewMember={true}
                />
            ) : (
                ''
            )}
            {filteredMembers.length === 0 && (
                <Card className='padding20'>
                    <p className='text-align-center'>
                        {translate('no_results')}
                    </p>
                </Card>
            )}
        </div>
    );
};

export default MembersCardsView;
